import SportsRow from "../components/SportsRow";

export default function Sports() {
  return (
    <div style={{ paddingTop: "100px" }}>
      <SportsRow />
    </div>
  );
}
